module.exports = __webpack_public_path__ + "5ca4b0f1e10fa32b3589189782e701fe.svg";